/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
	DataTag,
	DefinedInitialDataOptions,
	DefinedUseQueryResult,
	QueryClient,
	QueryFunction,
	QueryKey,
	UndefinedInitialDataOptions,
	UseQueryOptions,
	UseQueryResult
} from '@tanstack/react-query';

import { customInstance } from '.././instance';
import type { ErrorType } from '.././instance';
import type { PraetoidError, ShowInvitationResponse } from '../models';

/**
 * Displays invitation acceptance page for public access
 * @summary Show invitation details
 */
export const showInvitation = (token: string) => {
	return customInstance<ShowInvitationResponse>({ url: `/invite/${token}`, method: 'GET' });
};

export const getShowInvitationQueryKey = (token: string) => {
	return ['invite', token] as const;
};

export const getShowInvitationQueryOptions = <
	TData = Awaited<ReturnType<typeof showInvitation>>,
	TError = ErrorType<PraetoidError>
>(
	token: string,
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof showInvitation>>, TError, TData>>;
	}
) => {
	const { query: queryOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getShowInvitationQueryKey(token);

	const queryFn: QueryFunction<Awaited<ReturnType<typeof showInvitation>>> = () =>
		showInvitation(token);

	return { queryKey, queryFn, enabled: !!token, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof showInvitation>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ShowInvitationQueryResult = NonNullable<Awaited<ReturnType<typeof showInvitation>>>;
export type ShowInvitationQueryError = ErrorType<PraetoidError>;

export function useShowInvitation<
	TData = Awaited<ReturnType<typeof showInvitation>>,
	TError = ErrorType<PraetoidError>
>(
	token: string,
	options: {
		query: Partial<UseQueryOptions<Awaited<ReturnType<typeof showInvitation>>, TError, TData>> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof showInvitation>>,
					TError,
					Awaited<ReturnType<typeof showInvitation>>
				>,
				'initialData'
			>;
	},
	queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useShowInvitation<
	TData = Awaited<ReturnType<typeof showInvitation>>,
	TError = ErrorType<PraetoidError>
>(
	token: string,
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof showInvitation>>, TError, TData>> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof showInvitation>>,
					TError,
					Awaited<ReturnType<typeof showInvitation>>
				>,
				'initialData'
			>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useShowInvitation<
	TData = Awaited<ReturnType<typeof showInvitation>>,
	TError = ErrorType<PraetoidError>
>(
	token: string,
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof showInvitation>>, TError, TData>>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Show invitation details
 */

export function useShowInvitation<
	TData = Awaited<ReturnType<typeof showInvitation>>,
	TError = ErrorType<PraetoidError>
>(
	token: string,
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof showInvitation>>, TError, TData>>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
	const queryOptions = getShowInvitationQueryOptions(token, options);

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
		queryKey: DataTag<QueryKey, TData, TError>;
	};

	return { ...query, queryKey: queryOptions.queryKey };
}
